<template>
    <div ref="scriptContainer" class="w-full min-h-[500px]" data-test="mortgage-widget"></div>
</template>

<script setup>
import { onMounted, ref } from 'vue'

/**
 * 86bc8uyd2: the Mortgage Research Center VA finance widget, as on the tenant
 * Mortgage tab (V2/Properties/Tabs/Applicant/VaLoanTab.vue), for the self
 * credit check. A copy rather than a shared component so the self credit
 * check does not change the tenant pages.
 */
const scriptContainer = ref(null)

onMounted(() => {
    const script = document.createElement('script')
    script.src = 'https://www.mortgageresearchcenter.com/scripts/rentRisk.js'
    script.async = true
    script.setAttribute('data-mrc', 'RentRisk')
    script.setAttribute('data-mrc-color', '#c3a123')
    script.setAttribute('data-mrc-color-hover', '#323c61')
    script.setAttribute('data-mrc-desc', 'vafinance')

    script.onerror = () => console.error('Failed to load VA Loan script')

    if (scriptContainer.value) {
        scriptContainer.value.appendChild(script)
    }
})
</script>
